import { ExerciseBankItem, PaginatedResponse } from 'model';
import { createAsyncAction } from 'typesafe-actions';

export const getExerciseBankItems = createAsyncAction(
  'exerciseBank/GET_EXERCISEBANK_ITEMS_REQUEST',
  'exerciseBank/GET_EXERCISEBANK_ITEMS_SUCCESS',
  'exerciseBank/GET_EXERCISEBANK_ITEMS_FAILURE',
)<undefined, PaginatedResponse<ExerciseBankItem>, undefined>();
